import React, { ReactElement } from 'react';
import { Option, Select } from 'components/ui/Form/Select';
import { employeeSubTypeLabels, employeeSubTypes } from 'constants/employeeSubType';

export const getEmployeeSubTypeLabel = (employeeSubType?: string | null): string =>
  employeeSubType === employeeSubTypes.fixedTerm
    ? employeeSubTypeLabels[employeeSubTypes.fixedTerm]
    : employeeSubTypeLabels[employeeSubTypes.fullTime];

type Props = {
  selectedEmployeeSubType: string;
  onEmployeeSubTypeChange: (newEmployeeSubType: string) => void;
};

function EmployeeSubTypeFilter({
  selectedEmployeeSubType,
  onEmployeeSubTypeChange,
}: Props): ReactElement {
  const handleSubmit: React.FormEventHandler<HTMLFormElement> = (event) => {
    event.preventDefault();
  };

  return (
    <form onSubmit={handleSubmit}>
      <label htmlFor="employee-sub-type">
        <span>Employee Type</span>
        <Select
          className="m-0"
          id="employee-sub-type"
          name="employee_sub_type"
          value={selectedEmployeeSubType}
          onChange={(event: React.ChangeEvent<HTMLSelectElement>) =>
            onEmployeeSubTypeChange(event.target.value)
          }>
          <Option value={''}>All Employee Types</Option>
          <Option value={employeeSubTypes.fullTime}>
            {employeeSubTypeLabels[employeeSubTypes.fullTime]}
          </Option>
          <Option value={employeeSubTypes.fixedTerm}>
            {employeeSubTypeLabels[employeeSubTypes.fixedTerm]}
          </Option>
        </Select>
      </label>
    </form>
  );
}

export default EmployeeSubTypeFilter;
